module.exports = __webpack_public_path__ + "img/index-tjjl2.9b8edc20.png";